/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UITextInput from 'UIComponents/input/UITextInput';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import ToolSection from 'DesignComponents/tool/ToolSection';
import Number from 'ContentComponents/cmv2/fields/Number';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { NUMBER } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import DisplayTypes from 'ContentUtils/constants/CustomWidgetFieldDisplayTypes';
import { DEFAULT, STEP, MIN, MAX, PREFIX, SUFFIX, DISPLAY } from 'DesignData/enums/CustomWidgetFieldAttributes';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

function getNumericAttribute(value) {
  return value === null ? undefined : value;
}

export default class _class extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onAttributeChange = (attrName, e) => {
      const value = e.target.value;
      this.props.editField({
        [attrName]: value
      });
    };

    this.onDisplayChange = e => {
      this.props.editField({
        [DISPLAY]: e.target.name
      });
    };
  }

  renderDisplayOptions() {
    const {
      field
    } = this.props;
    const radios = Object.values(DisplayTypes[NUMBER]).map(displayType => {
      const checked = field[DISPLAY] === displayType;
      return /*#__PURE__*/_jsx(UIRadioInput, {
        checked: checked,
        inline: true,
        name: displayType,
        onChange: this.onDisplayChange,
        size: "small",
        className: "content-options-radio-input",
        children: text(i18nKey(`display.displayTypeLabels.${displayType}`))
      }, displayType);
    });
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('display.label')
      }),
      children: /*#__PURE__*/_jsx(Fragment, {
        children: radios
      })
    });
  }

  render() {
    const {
      field,
      fieldErrors,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(ToolFieldset, {
        children: [/*#__PURE__*/_jsx(ToolSection, {
          flush: true,
          children: /*#__PURE__*/_jsxs(UIFlex, {
            children: [/*#__PURE__*/_jsx(ToolFormControl, {
              className: "m-right-2",
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('number.prefix.label')
              }),
              tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('number.prefix.tooltip')
              }),
              children: /*#__PURE__*/_jsx(SidebarInput, {
                inputComponent: UITextInput,
                onChange: (...partialArgs) => this.onAttributeChange(PREFIX, ...partialArgs),
                value: field[PREFIX] || '',
                readOnly: readOnly
              })
            }), /*#__PURE__*/_jsx(ToolFormControl, {
              className: "m-top-0",
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('number.suffix.label')
              }),
              tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('number.suffix.tooltip')
              }),
              children: /*#__PURE__*/_jsx(SidebarInput, {
                inputComponent: UITextInput,
                onChange: (...partialArgs) => this.onAttributeChange(SUFFIX, ...partialArgs),
                value: field[SUFFIX] || '',
                readOnly: readOnly
              })
            })]
          })
        }), /*#__PURE__*/_jsx(ToolSection, {
          flush: true,
          children: /*#__PURE__*/_jsxs(UIFlex, {
            children: [/*#__PURE__*/_jsx(FormControlWithErrors, {
              className: "m-right-2",
              errors: fieldErrors[MIN],
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('number.min')
              }),
              children: /*#__PURE__*/_jsx(SidebarInput, {
                inputComponent: UIStepperInput,
                onChange: (...partialArgs) => this.onAttributeChange(MIN, ...partialArgs),
                value: field[MIN],
                readOnly: readOnly
              })
            }), /*#__PURE__*/_jsx(ToolFormControl, {
              className: "m-top-0",
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('number.max')
              }),
              children: /*#__PURE__*/_jsx(SidebarInput, {
                inputComponent: UIStepperInput,
                onChange: (...partialArgs) => this.onAttributeChange(MAX, ...partialArgs),
                value: field[MAX],
                readOnly: readOnly
              })
            })]
          })
        }), /*#__PURE__*/_jsx(ToolSection, {
          flush: true,
          children: /*#__PURE__*/_jsx(ToolFormControl, {
            className: "m-top-0",
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('number.step')
            }),
            children: /*#__PURE__*/_jsx(SidebarInput, {
              inputComponent: UIStepperInput,
              onChange: (...partialArgs) => this.onAttributeChange(STEP, ...partialArgs),
              value: field[STEP],
              readOnly: readOnly
            })
          })
        }), /*#__PURE__*/_jsxs(ToolSection, {
          flush: true,
          children: [this.renderDisplayOptions(), /*#__PURE__*/_jsx(FormControlWithErrors, {
            errors: fieldErrors[DEFAULT],
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(`defaultLabels.${NUMBER}`)
            }),
            children: /*#__PURE__*/_jsx(SidebarInput, {
              display: field[DISPLAY],
              inputComponent: Number // force remount when prefix/suffix because otherwise
              // they won't show up until the default value is edited
              ,
              onFieldChange: this.onDefaultChange,
              max: getNumericAttribute(field[MAX]),
              min: getNumericAttribute(field[MIN]),
              prefix: field[PREFIX],
              readOnly: readOnly,
              step: getNumericAttribute(field[STEP]),
              suffix: field[SUFFIX],
              value: field[DEFAULT]
            }, `${field[PREFIX]}-${field[SUFFIX]}`)
          })]
        })]
      })
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  readOnly: PropTypes.bool
};
_class.defaultProps = {
  fieldErrors: {}
};